import { Header } from '../components/Header.jsx'
import { getViewData } from './MenuView'
import experienceData from '../data/experience.json'

export const ExperienceView = () => {
  const viewData = getViewData('experience')

  return (
    <>
      <Header
        title={viewData.title}
        icon={viewData.icon}
        description={viewData.description}
      />
      <ul className='experience_container'>
        {experienceData.data.map((work) => (
          <li className='experience icon_grid icon_grid-lg' key={work.name}>
            <img
              src={work.src}
              className={work.logoPadding && 'img-pad'}
              alt={work.name}
            />
            <div className='experience_details'>
              <a href={work.site} target='_blank' rel='noopener noreferrer'>
                <h3>{work.name}</h3>
                {work.site && (
                  <span className='material-symbols-rounded'>open_in_new</span>
                )}
              </a>
              <div>
                {work.type && <span>{work.type}</span>}
                <span>{work.duration}</span>
                <span>
                  {work.location} ({work.nature})
                </span>
              </div>
            </div>
            <div />
            <div className='experience_titles'>
              {work.roles.map((role, index) => (
                <div key={`${role}+${index}`} className='icon_grid'>
                  <span className='material-symbols-rounded'>badge</span>
                  <div>
                    <h4>{role.title}</h4>
                    <p>{role.description}</p>
                  </div>
                  <div />
                  <ul>
                    {role.accomplishments.map((task, index) => (
                      <li key={index}>
                        <span>
                          <em>{task.title} - </em>
                          {task.text}
                        </span>
                      </li>
                    ))}
                  </ul>
                  {role.tech && (
                    <>
                      <div />
                      <h4>Tech: {role.tech.join(' | ')}</h4>
                    </>
                  )}
                </div>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </>
  )
}
